import { render, staticRenderFns } from "./BaseSeal.vue?vue&type=template&id=e8637076"
import script from "./BaseSeal.vue?vue&type=script&lang=js"
export * from "./BaseSeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports